import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Spacer from '../components/Spacer';
import Profile from '../components/Profile';

function AboutMe() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Person',
            name: 'Maria Chavez-Brown',
            jobTitle: 'Licensed Clinical Social Worker',
            description: 'Learn more about Maria Chavez-Brown, M.S.W., L.C.S.W., and her professional background.',
            url: 'https://cvtherapy.org/about-me',
            image: 'https://cvtherapy.org/assets/logo.svg',
            worksFor: {
              '@type': 'LocalBusiness',
              name: 'CV Therapy',
              url: 'https://cvtherapy.org',
            },
            alumniOf: [
              {
                '@type': 'CollegeOrUniversity',
                name: 'University of Southern California',
                url: 'https://www.usc.edu/',
              },
            ],
            hasCredential: [
              {
                '@type': 'EducationalCredential',
                credentialCategory: 'license',
                name: 'Licensed Clinical Social Worker',
                educationalLevel: 'Graduate',
              },
            ],
            sameAs: [
              'https://www.linkedin.com/in/maria-chavez-brown-lcsw-078b97160',
              'https://www.psychologytoday.com/profile/890288',
            ],
          })}
        </script>
      </Helmet>
      <Spacer />
      <div className="container" style={{ minHeight: 1000 }}>
        <h1 className="display-4 text-center text-primary">{t('aboutMe.title')}</h1>
        <div className="row">
          <div className="col-12 pb-3">
            <Profile
              header={t('aboutMe.profileHeader')}
              name={t('aboutMe.profileName')}
              image={t('aboutMe.profileImage')}
              schools={t('aboutMe.profileSchools')}
              desc={t('aboutMe.profileDesc')}
              alt="Maria Chavez-Brown, M.S.W., L.C.S.W."
            />
          </div>
        </div>
        <p className="text-primary">{t('aboutMe.p1')}</p>
        <p className="text-primary">{t('aboutMe.p2')}</p>
        <p className="text-primary">{t('aboutMe.p3')}</p>
        <p className="text-primary">{t('aboutMe.p4')}</p>
        <p className="text-primary">{t('aboutMe.p5')}</p>
        <p className="mt-5 text-primary">{t('aboutMe.signature')}</p>
      </div>
    </>
  );
}

export default AboutMe;
